<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Confirm Your Email</title>
</svelte:head>

<script>
  import Button from '@components/buttons/button.svelte'
  import { Link, page, useForm } from '@inertiajs/svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'

  let token = $derived($page.props.token)

  const form = useForm({})

  function handleSubmit(e) {
    e.preventDefault()
    $form.post(`/user_confirmation/${token}/confirm`)
  }
</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-32" />
    </div>

    <div class="auth-form text-center">
      <h1 class="text-3xl font-serif text-gray-700 mb-4">Confirm your email</h1>
      <p class="text-gray-600 mb-8">
        One more step: confirm your email address to finish activating your account.
      </p>

      <form id="user-confirmation-show-form" onsubmit={handleSubmit}>
        <Button
          type="submit"
          variant="bold"
          size="lg"
          class="w-full h-12 border-none hover:border-none justify-center"
          text="Confirm email address"
          loading={$form.processing}
        />
      </form>
    </div>
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    <Link href="/session/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Back to sign in</Link>
  </div>
</div>
